import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export interface MediumDto {
  id: number;
  title: string;
}

export default class MediumApi {
  static uri = "n/internet/medium";
  context: AuthContextProps;

  constructor(context: AuthContextProps) {
    this.context = context;
  }

  getAll(): Promise<MediumDto[]> {
    return getData({ uri: MediumApi.uri, context: this.context });
  }
}
